import { Table, Spin } from 'antd';
import React from 'react';

import './AnnouncementsTable.scss';

const className = 'c-CourseOfferAnnouncementsContainer-AnnouncementTable';

const AnnouncementsTable = ({
  data,
  current,
  totalCount,
  onPaginationChange,
  fetching,
  columns,
  withHighlight,
}) => (
  <div>
    {fetching ? <Spin /> : null}
    {data.length > 0 ? (
      <div>
        <div>Total count: {totalCount}</div>
        <Table
          columns={columns}
          tableLayout="auto"
          dataSource={data}
          rowClassName={(record) =>
            record?.leadTrainer?.selected && withHighlight
              ? `${className}__assigned`
              : ''
          }
          expandable={{ defaultExpandAllRows: true }}
          pagination={{
            current,
            total: totalCount,
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30'],
          }}
          onChange={onPaginationChange}
        />
      </div>
    ) : null}
    {data.length === 0 && !fetching ? <div>No record found</div> : null}
  </div>
);

export default AnnouncementsTable;
